import React from 'react';
import { recordCarouselControlClickEvent } from './carouselControlClickEvents';
import * as styles from './CarouselSliderButton.module.scss';
import Button from '../../components/Button';
import SVGIcon from '../../components/SVGIcon';
import firstIcon from '../../icons/carousel-slider-button-first.svg';
import nextIcon from '../../icons/carousel-slider-button-next.svg';
import previousIcon from '../../icons/carousel-slider-button-previous.svg';

interface CarouselSliderButtonProps {
  direction: 'previous' | 'next';
  imageCount: number;
  selectedIndex: number;
  onSelectedIndexChange: (index: number) => void;
}

const CarouselSliderButton = ({
  direction,
  imageCount,
  selectedIndex,
  onSelectedIndexChange,
}: CarouselSliderButtonProps) => {
  const button = (() => {
    if (direction === 'previous') {
      return { icon: previousIcon, label: 'Previous Slide' };
    }
    return selectedIndex < imageCount - 1
      ? { icon: nextIcon, label: 'Next Slide' }
      : { icon: firstIcon, label: 'Back to the First slide' };
  })();

  return (
    <Button
      aria-label={button.label}
      className={styles.button}
      onClick={({ nativeEvent }) => {
        recordCarouselControlClickEvent(nativeEvent);

        if (direction === 'next') {
          onSelectedIndexChange((selectedIndex + 1) % imageCount);
        } else {
          onSelectedIndexChange((selectedIndex - 1 + imageCount) % imageCount);
        }
      }}
    >
      <SVGIcon className={styles.img} size={48}>
        {button.icon}
      </SVGIcon>
    </Button>
  );
};

export default CarouselSliderButton;
